import { addTaskMenutId } from '../config/constants.js';

export default () => {
    document.querySelector('.attachviewer')?.remove();
    $$(addTaskMenutId).destructor();
};
